(function () {
  'use strict';
  if (window.QFTeslaGiftGuard) return;
  var kits = [50015559418146, 50015559450914];
  var tonic = 52309891186978;
  var oil = 52453485510946;
  var otherRules = {
    51771371979042: [50343132987682],
    51771373846818: [50343132987682],
    51771172290850: [50015559418146, 50015559156002, 51700231340322],
    51771171406114: [50015559418146, 50015559156002, 51700231340322],
    51771441152290: [50015559450914, 50015559418146],
    51771441643810: [50015559450914, 50015559418146],
    51700235010338: [50015559450914],
    51700231340322: [50015559450914]
  };
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  var bypass = false;
  var checkingOut = false;
  var refreshTimer;

  function plan(cart) {
    var items = cart.items || [];
    var present = items.filter(function (item) { return item.quantity > 0; }).map(function (item) { return Number(item.variant_id); });
    var eligible = kits.some(function (id) { return present.indexOf(id) !== -1; });
    var updates = {};
    var keptTonic = false;
    items.forEach(function (item) {
      var id = Number(item.variant_id);
      if (id === oil) updates[item.key] = 0;
      else if (id === tonic) {
        var quantity = eligible && !keptTonic ? 1 : 0;
        if (quantity === 1) keptTonic = true;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      } else if (otherRules[id]) {
        if (!otherRules[id].some(function (parent) { return present.indexOf(parent) !== -1; })) updates[item.key] = 0;
      }
    });
    return { updates: updates, addTonic: eligible && !keptTonic };
  }

  async function request(path, data) {
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (data) {
      options.method = 'POST';
      options.headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      options.body = JSON.stringify(data);
    }
    var response = await nativeFetch(root + path, options);
    if (!response.ok) throw new Error('Não foi possível conferir o brinde. Tente novamente.');
    return response.json();
  }

  function notify(cart) {
    document.dispatchEvent(new CustomEvent('qf:gift-corrected', { detail: { cart: cart } }));
    if (/\/cart\/?$/.test(window.location.pathname) && !checkingOut) {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () { if (!checkingOut) window.location.reload(); }, 150);
    }
  }

  async function reconcile() {
    var cart = await request('cart.js');
    var changed = false;
    for (var attempt = 0; attempt < 4; attempt++) {
      var action = plan(cart);
      var keys = Object.keys(action.updates);
      if (!keys.length && !action.addTonic) {
        if (changed) notify(cart);
        return cart;
      }
      if (keys.length) {
        cart = await request('cart/update.js', { updates: action.updates });
      } else {
        await request('cart/add.js', { items: [{ id: tonic, quantity: 1 }] });
        cart = await request('cart.js');
      }
      changed = true;
    }
    throw new Error('Não foi possível conferir o brinde. Atualize o carrinho e tente novamente.');
  }

  function enqueue(task) {
    var result = queue.then(task);
    queue = result.catch(function () {});
    return result;
  }

  function ensure() { return enqueue(reconcile); }

  window.QFTeslaGiftGuard = { ensure: ensure, plan: plan };
  window.fetch = function (input, options) {
    var url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href); } catch (error) { return nativeFetch(input, options); }
    if (url.origin !== window.location.origin || !/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname)) return nativeFetch(input, options);
    return enqueue(async function () {
      var response = await nativeFetch(input, options);
      if (response.ok) await reconcile();
      return response;
    });
  };

  function showError(error) {
    checkingOut = false;
    var box = document.getElementById('qf-gift-error');
    if (!box) {
      box = document.createElement('p');
      box.id = 'qf-gift-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;bottom:20px;left:16px;right:16px;z-index:2147483647;background:#fff;color:#8b2020;border:1px solid #8b2020;padding:16px;font:16px Open Sans,Arial,sans-serif';
      document.body.appendChild(box);
    }
    box.textContent = error.message || 'Não foi possível conferir o brinde. Tente novamente.';
  }

  function beforeCheckout(event, resume) {
    if (bypass) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    clearTimeout(refreshTimer);
    ensure().then(function () {
      var box = document.getElementById('qf-gift-error');
      if (box) box.remove();
      bypass = true;
      try { resume(); } finally { bypass = false; checkingOut = false; }
    }).catch(showError);
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"],#checkout-submit');
    if (target) beforeCheckout(event, function () { target.click(); });
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var action = form.getAttribute('action') || '';
    var submitter = event.submitter;
    var checkout = /\/checkout(?:\?|$)/.test(action) || (submitter && submitter.name === 'checkout') || form.querySelector('[name="cart-discount-field"]');
    if (checkout) beforeCheckout(event, function () { form.requestSubmit(submitter || undefined); });
  }, true);

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { ensure().catch(function () {}); }, 200);
  }
  ['cart:updated', 'cart-update', 'alpine:initialized', 'eurus:cart:items-changed'].forEach(function (name) { document.addEventListener(name, schedule); });
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
